
































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop() stadiumGroundId!: number;

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "服务名称", dataIndex: "service_name" },
    { title: "服务状态", scopedSlots: { customRender: "service_status" } }
  ];

  async loadData1() {
    this.loading = true;
    const res = await this.$store.dispatch("stadium/getGroundRobots", {
      stadium_ground_id: this.stadiumGroundId
    });
    if (res && res.Data) {
      this.data = res.Data;
    }
    this.loading = false;
  }

  mounted() {
    this.loadData1();
  }

  async changeServiceStatus(val: any, id: number) {
    this.$confirm({
      title: "确认信息",
      content: "您确定要操作吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/changeGroundRobotStatus", {
          stadium_id: this.stadiumId,
          stadium_ground_id: this.stadiumGroundId,
          service_id: id,
          val
        });
        // console.log(res)
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
          this.loadData1();
        } else {
          this.$message.error("操作失败");
        }
      }
    });
  }
}
